import { reactive } from 'vue'
import { useWorkspaceStore } from 'app/services/pinia/workspace-store'

export const createAddEquationAction = () => {
  return reactive({
    get isEnabled() {
      const editorState = useWorkspaceStore().editor
      const workbook = useWorkspaceStore().workbook

      if (workbook && editorState) {
        const mapLoaded = editorState.mapStatus === 'loaded'
        return mapLoaded && workbook.isFocused && !workbook.isInEditTitleMode.value && workbook.selectionIds.length > 0
      }
      return false
    },
  })
}
